import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Home from './pages/Home';
import OrderProducts from './pages/OrderProducts';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import ProjectLeadership from './pages/ProjectLeadership';
import SolutionArchitect from './pages/SolutionArchitect';
import About from './pages/About';
import Login from './pages/Login';
import {
  AdminCategories,
  AdminProducts,
  AdminOrders,
  AdminUsers,
  AdminCompanies,
} from './pages/Admin';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        © {new Date().getFullYear()} Scott Mason — Full Stack Developer &amp; Data Scientist
      </div>
    </footer>
  );
}

export default function App() {
  const [cartItems, setCartItems] = useState([]);

  const addToCart = (product, count) => {
    setCartItems(prev => {
      const existing = prev.findIndex(i => i.product.id === product.id);
      if (existing >= 0) {
        const updated = [...prev];
        updated[existing] = { ...updated[existing], count: updated[existing].count + count };
        return updated;
      }
      return [...prev, { product, count }];
    });
  };

  const updateQty = (index, newCount) => {
    if (newCount <= 0) {
      removeItem(index);
      return;
    }
    setCartItems(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], count: newCount };
      return updated;
    });
  };

  const removeItem = (index) => {
    setCartItems(prev => prev.filter((_, i) => i !== index));
  };

  const cartCount = cartItems.reduce((sum, item) => sum + item.count, 0);

  return (
    <Router>
      <Navbar cartCount={cartCount} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/order-products" element={<OrderProducts />} />
        <Route path="/products/:id" element={<ProductDetail addToCart={addToCart} />} />
        <Route path="/cart" element={<Cart cartItems={cartItems} updateQty={updateQty} removeItem={removeItem} />} />
        <Route path="/project-leadership" element={<ProjectLeadership />} />
        <Route path="/solution-architect" element={<SolutionArchitect />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin/categories" element={<AdminCategories />} />
        <Route path="/admin/products" element={<AdminProducts />} />
        <Route path="/admin/orders" element={<AdminOrders />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/companies" element={<AdminCompanies />} />
        <Route path="*" element={
          <div className="page-wrapper">
            <div className="container" style={{ textAlign: 'center', paddingTop: '3rem' }}>
              <h2 style={{ fontFamily: 'var(--font-display)', color: 'var(--primary)', marginBottom: '1rem' }}>Page Not Found</h2>
              <a href="/" className="btn btn-primary">Go Home</a>
            </div>
          </div>
        } />
      </Routes>
      <Footer />
    </Router>
  );
}
